import React, { useState, useEffect } from "react";
import editIcon from "../../assets/icons/editIcon.svg";
import "./SwitchClient.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Radio } from "antd";
import { setActiveClient } from "../../app/slice/clientSlice";

import { useDispatch, useSelector } from "react-redux";
import { getAllClients } from "../../apis/createEnvApi/createEnvApi";
import { Link } from "react-router-dom";
import SwitchClientActions from "../../components/SwitchClientActions/SwitchClientActions";

function SwitchClient() {
  const dispatch = useDispatch();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const [clients, setClients] = useState<any[]>([]);
  const [filteredClients, setFilteredClients] = useState<any[]>([]);

  useEffect(() => {
    getClientData();
    console.log("EmpId-->", EmpId);
  }, [EmpId]);

  const getClientData = () => {
    getAllClients(EmpId, (res: any) => {
      console.log("getALLClientApi::", res);
      setClients(res);
      setFilteredClients(res);
    });
  };
  const handleClientChange = (client: any) => {
    console.log("handleClientChange::", client);
    dispatch(setActiveClient(client));
  };
  const handleSearch = (value: any) => {
    let searchValue = value.toLowerCase();
    if (searchValue.length >= 2) {
      let cls = clients.filter((item: any) =>
        item.Client_Name.toLowerCase().startsWith(searchValue)
      );
      setFilteredClients(cls);
    } else {
      setFilteredClients(clients);
    }
  };

  return (
    <>
      <div className="switch-client">
        <div className="switch-client-header">
          <div className="current-client-title-section">
            <div className="client-label">Current Client:</div>
            <div className="client-name">{ActiveClient?.Client_Name}</div>
          </div>
          <div className="seach-client-section">
            <div className="search-box">
              <FontAwesomeIcon
                className="search-icon"
                icon={["fas", "magnifying-glass"]}
              />

              <div className="search-input-section">
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search Client"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="switch-client-body">
          <div className="client-list-header">
            <div className="client-li-item  font-bold">Client name</div>
            <div className="client-li-item  font-bold">Switch</div>
            <div className="client-li-item  font-bold">Client ID</div>
            <div className="client-li-item  font-bold">Actions</div>
          </div>
          <ul className="client-list-section" id="client-list-section">
            {filteredClients.map((item: any) => {
              return (
                <li className="client-list-item-section" key={item.Client_Id}>
                  <div className="client-li-item">{item.Client_Name}</div>
                  <div className="client-li-item">
                    <Radio.Group
                      onChange={() => handleClientChange(item)}
                      value={ActiveClient.Client_Id}
                    >
                      <Radio className="radio-css" value={item.Client_Id}>
                        {ActiveClient.Client_Id == item.Client_Id
                          ? "Current"
                          : ""}
                      </Radio>
                    </Radio.Group>
                  </div>
                  <div className="client-li-item">{item.Client_Id}</div>
                  <div className="client-li-item">
                    <SwitchClientActions rowData={item} />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
}

export default SwitchClient;
